import axios from 'axios'

var axiosInstance
if(window.location.hostname === "integration-grand-public-lamp.bleu122.com") {
  axiosInstance = axios.create({
    baseURL: "https://integration-lamp.bleu122.com",
    headers: {
      'Content-Type': 'application/json'
    }
  })
} else {
  axiosInstance = axios.create({
    baseURL: process.env.SERVER_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
const instance = axiosInstance

export default instance



// WEBPACK FOOTER //
// ./src/services/api.js